import { Component, OnInit, ChangeDetectorRef, ViewEncapsulation } from '@angular/core';
import { ClmtlkSessionService } from 'app/clmtlk/shared/service/clmtlk-session.service';
import { ConversationContact, ConversationMarginal } from 'app/clmtlk/shared/model/conversationContacts';
import { ClmtlkService } from 'app/clmtlk/shared/service/clmtlk.service';

@Component({
  selector: 'clmtlk-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HeaderComponent implements OnInit {

  loggedInUser: ConversationContact = <ConversationContact>{};
  htmlHeaderContent: string;

  constructor(public clmtlkSessionService: ClmtlkSessionService,
     private cdr: ChangeDetectorRef,
     private clmtlkService: ClmtlkService) {}

  ngOnInit() {

    this.clmtlkSessionService.loggedInUserObserver.subscribe(loggedInContact => {
        this.loggedInUser = loggedInContact;
        this.cdr.detectChanges();
    });

    this.clmtlkSessionService.headerTemplateObserver.subscribe( (conversationMarginals: ConversationMarginal[]) => {

        conversationMarginals.forEach( conversationMarginal => {
          if (conversationMarginal.MARG_TMPL_TYP_CD === 'H') {
              this.htmlHeaderContent = conversationMarginal.CTX_MARG_XML.replace('<![CDATA[', '').replace(']]>', '');
          }
        });
    });

  }


}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/CLAIMS_PIPELINE/CLMTLK_UI_APP_PIPELINE/src/app/clmtlk/core/header/header.component.ts